import { render } from "./CheckoutItemComponent.vue?vue&type=template&id=f2ce2f6e"
import script from "./CheckoutItemComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutItemComponent.vue?vue&type=script&lang=js"

import "./CheckoutItemComponent.vue?vue&type=style&index=0&id=f2ce2f6e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__